module.exports = function() {
  return new Worker(__webpack_public_path__ + "0a72703060a41c53d2b7.worker.js");
};